import React from 'react';
import { StoreContext } from '../mobx/context';

export const UseStores = () => React.useContext(StoreContext);
